const STORAGE_KEY = 'delegonCurrentCompany';

const read = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
};

const write = (value) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {}
};

const isEligible = (user) => user.status === 'active' && user.Company?.Status === 'active';

const isActiveMember = (account, companyID) =>
  account.users?.some((user) => user.Company?.company_id === companyID && isEligible(user)) ?? false;

export const eligibleMemberships = (account) => account?.users?.filter(isEligible) ?? [];

export const selectedMembershipId = () => read()?.userID ?? null;

export const selectMembership = (account, user) =>
  write({ accountID: account.account_id, userID: user.user_id, companyID: user.Company.company_id, name: user.Company.Name });

export const selectMembershipId = (userID) => write({ userID });

export const clearSelection = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
};

export const adoptLinkedMembership = () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('as')) {
    return;
  }

  const userID = Number(url.searchParams.get('as'));
  url.searchParams.delete('as');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);

  if (Number.isInteger(userID) && userID > 0) {
    write({ userID, linked: true });
  }
};

export const detectCompanySwitch = (account, user) => {
  const company = user?.Company;
  if (!account?.account_id || !company?.company_id) {
    return null;
  }

  const previous = read();
  selectMembership(account, user);

  if (previous?.linked) {
    if (previous.userID === user.user_id) {
      return null;
    }

    const linked = account.users?.find((member) => member.user_id === previous.userID);
    return { linked: true, from: linked?.Company?.Name ?? null, to: company.Name };
  }

  if (previous?.accountID !== account.account_id || previous.companyID === company.company_id) {
    return null;
  }

  return { from: previous.name, to: company.Name, fromActive: isActiveMember(account, previous.companyID) };
};
